import {
  exportJobResponse,
  exportJobStatus,
  exportStatusResponse,
} from "@/schemas/exportData";
import { z } from "@/zod";

export const CONTENT_TYPE_MAP = {
  csv: "text/csv",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

export type ExportJobStatus = z.infer<typeof exportJobStatus>;

export type ExportJobResponse = z.infer<typeof exportJobResponse>;

export type ExportStatusResponse = z.infer<typeof exportStatusResponse>;
